import { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { fetchCep } from '../../../lib/cepLib';
import { onlyNumbers } from '../../../utils/validators';

const ZIP_CODE_LENGTH = 8;
const EMPTY_LOOKUP_FIELDS = {
  city: '',
  streetDescription: '',
  state: '',
  neighborhood: '',
  country: '',
};

const useAddressZipCode = (name: string) => {
  const { setValue } = useFormContext();
  const streetNumberRef = useRef<HTMLInputElement>(null);
  const [isLoadingAddress, setIsLoadingAddress] = useState(false);

  const changeAddressFields = (fields: Record<string, string | undefined>) => {
    for (const [field, value] of Object.entries(fields)) {
      setValue(`${name}.${field}`, value, { shouldDirty: true, shouldValidate: Boolean(value) });
    }
  };

  const fetchAddressByZipCode = async (zipCode: string) => {
    try {
      const address = await fetchCep(zipCode);
      changeAddressFields({
        city: address.city,
        municipalityCode: address.municipalityCode,
        streetDescription: address.streetDescription || '',
        state: address.state,
        neighborhood: address.neighborhood,
        country: 'Brasil',
      });
    } catch (error) {
      if ((error as { type?: string })?.type === 'service_error') {
        changeAddressFields(EMPTY_LOOKUP_FIELDS);
      }
    }
  };

  const loadAddress = async (value: string) => {
    const zipCode = onlyNumbers(value);

    if (zipCode.length !== ZIP_CODE_LENGTH) {
      return;
    }

    setIsLoadingAddress(true);
    await fetchAddressByZipCode(zipCode);
    setIsLoadingAddress(false);

    streetNumberRef.current?.focus();
  };

  return {
    isLoadingAddress,
    streetNumberRef,
    loadAddress,
  };
};

export default useAddressZipCode;
